
import { Component, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import { apiGetSupplyModelList, apiSetSupplyStatus } from "@/api/model";
import ShopList from "@/components/shop-list.vue";

@Component({
    components: {
        lsPagination,
        ShopList,
    },
})
export default class SupplyReviewModelList extends Vue {
    /** S Data **/

    pager: RequestPaging = new RequestPaging();
    dialogPager: RequestPaging = new RequestPaging();
    searchForm: any = {
        model_code: "",
        code: "",
        shop_sn: "",
        model_name: "",
        shop_name: "",
        market_status: "",
    };
    statusList: any = [
        // { label: '未审核', value: 0 },
        { label: "审核通过", value: 1 },
        { label: "审核中", value: -1 },
        { label: "已拒绝", value: -2 },
    ];
    selectIds: any = [];
    apiGetSupplyModelList = apiGetSupplyModelList;

    /** E Data **/
    getList() {
        this.pager.request({
            callback: apiGetSupplyModelList,
            params: {
                ...this.searchForm,
            },
        });
    }

    // 重置搜索
    reset(): void {
        this.searchForm.page = 1;
        this.getList();
    }

    handleSelectionChange(value: any) {
        this.selectIds = value.map((item: any) => item.id);
    }

    async handleSave(type: number, id: number) {
        if (type == 1) {
            await this.$confirm(`确定通过模型审核吗？`, "提示", {});
            await apiSetSupplyStatus({
                goods_ids: id ? [id] : this.selectIds,
                supply_status: 1,
            });
            this.getList();
        } else {
            await this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }).then((res: any) => {
                if (res.action === "confirm") {
                    if (!res.value)
                        return this.$message.error("请输入拒绝原因");
                    apiSetSupplyStatus({
                        goods_ids: id ? [id] : this.selectIds,
                        supply_status: -2,
                        supply_desc: res.value,
                    }).then(() => {
                        this.getList();
                    });
                }
            });
        }
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getList();
    }
}
